var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0493164,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#FFECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 24.5493C35 23.6301 34.8189 22.7198 34.4672 21.8705C34.1154 21.0213 33.5998 20.2496 32.9497 19.5996C32.2997 18.9496 31.5281 18.4339 30.6788 18.0822C29.8295 17.7304 28.9193 17.5493 28 17.5493C27.0807 17.5493 26.1705 17.7304 25.3212 18.0822C24.4719 18.4339 23.7003 18.9496 23.0503 19.5996C22.4002 20.2496 21.8846 21.0213 21.5328 21.8705C21.1811 22.7198 21 23.6301 21 24.5493C21 25.9363 21.41 27.2263 22.105 28.3143H22.097C24.457 32.0093 28 37.5493 28 37.5493L33.903 28.3143H33.896C34.6164 27.1907 34.9995 25.8841 35 24.5493ZM28 27.5493C27.2044 27.5493 26.4413 27.2332 25.8787 26.6706C25.3161 26.108 25 25.345 25 24.5493C25 23.7537 25.3161 22.9906 25.8787 22.428C26.4413 21.8654 27.2044 21.5493 28 21.5493C28.7956 21.5493 29.5587 21.8654 30.1213 22.428C30.6839 22.9906 31 23.7537 31 24.5493C31 25.345 30.6839 26.108 30.1213 26.6706C29.5587 27.2332 28.7956 27.5493 28 27.5493Z",
    fill: "#F53838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a4285534.svg";
export { ForwardRef as ReactComponent };